import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./changePassword.css";
import TextInput from "../TextInputComponent/TextInput";
import Button from "../ButtonComponent/Button";
import CloseIcon from "../../assets/images/Icons/closeIcon.svg";
import EyeVisible from "../../assets/images/eyeVisible.svg";

import EyeInVisible from "../../assets/images/eyeInVisible.svg";
const ModalChangePassword = ({
  show,
  setShow,
  handleSubmit = () => setShow(false),
  setOldPassword,
  setPasswordNew,
  setPasswordConfirm,
  password,
  passwordNew,
  passwordConfirm,
  passwordType = "Password",
  setPasswordType,
  newPasswordType = "Password",
  setNewPasswordType,
  confirmPasswordType = "Password",
  setConfirmPasswordType,
  buttonText = "Submit",
  newpasswordInavalid = false,
  confirmPasswordInavalid = false,
  oldPasswordInavalid = false,
  passWordMisMatch = false,
  setPasswordMisMatch,
}) => {
  return (
    <div className="containerPasswordChange">
      <Modal show={show} className="modalChagePassword">
        <div className="changePasswordOutLine">
          <h5 className="passwordTextChangeModal">Change Password</h5>
          <div
            className="closeButtonChangePassword"
            onClick={() => setShow(false)}
          >
            <img className="btnCloseChangepasrd" src={CloseIcon} alt="Close" />
          </div>

          <div className="passwordContaier">
            <div className="passwordOldChange">
              <div className="changepwdDiv">
                <TextInput
                  placeholder="Old Password"
                  value={password}
                  type={passwordType}
                  onChange={(e) => {
                    let value = e.target.value;

                    setOldPassword(e.target.value);
                  }}
                />
                {oldPasswordInavalid ? (
                  <div className="invalid-textDispaly">
                    Please enter old password
                  </div>
                ) : (
                  ""
                )}
                {passwordType === "password" ? (
                  <i className="bi bi-eye-slash">
                    <img
                      src={EyeVisible}
                      onClick={() => {
                        setPasswordType("text");
                      }}
                    />
                  </i>
                ) : (
                  <i className="bi bi-eye-slash">
                    <img
                      src={EyeInVisible}
                      onClick={() => {
                        setPasswordType("password");
                      }}
                    />
                  </i>
                )}
              </div>
            </div>
            <div className="newpasswordChange">
              <div className="changepwdDiv">
                <TextInput
                  placeholder="New Password"
                  value={passwordNew}
                  type={newPasswordType}
                  onChange={(e) => {
                    let value = e.target.value;
                    setPasswordNew(e.target.value);
                  }}
                />
                {newpasswordInavalid ? (
                  <div className="invalid-textDispaly">
                    Please enter new password
                  </div>
                ) : (
                  ""
                )}
                {newPasswordType === "password" ? (
                  <i className="bi bi-eye-slash">
                    <img
                      src={EyeVisible}
                      onClick={() => {
                        setNewPasswordType("text");
                        // setPasswordType("text");
                      }}
                    />
                  </i>
                ) : (
                  <i className="bi bi-eye-slash">
                    <img
                      src={EyeInVisible}
                      onClick={() => {
                        setNewPasswordType("password");
                        // setPasswordType("password");
                      }}
                    />
                  </i>
                )}
              </div>
            </div>
            <div className="confirmPasswordChage">
              <div className="changepwdDiv">
                <TextInput
                  placeholder="Confirm Password"
                  type={confirmPasswordType}
                  value={passwordConfirm}
                  onChange={(e) => {
                    let value = e.target.value;
                    setPasswordConfirm(e.target.value);
                  }}
                />
                {confirmPasswordInavalid ? (
                  <div className="invalid-textDispaly">
                    Please enter confirm password
                  </div>
                ) : (
                  ""
                )}

                {confirmPasswordType === "password" ? (
                  <i className="bi bi-eye-slash">
                    <img
                      src={EyeVisible}
                      onClick={() => {
                        setConfirmPasswordType("text");
                      }}
                    />
                  </i>
                ) : (
                  <i className="bi bi-eye-slash">
                    <img
                      src={EyeInVisible}
                      onClick={() => {
                        setConfirmPasswordType("password");
                      }}
                    />
                  </i>
                )}

                {passWordMisMatch ? (
                  <div className="invalid-textDispaly">
                    Passwords do not match
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>

          <div className="buttonSubmit">
            <Button text={buttonText} onClick={handleSubmit}></Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ModalChangePassword;
